import { FirebaseClient } from '@/api/firebaseClient';
import { QUERY_KEYS } from '@/api/queries';
import { Button } from '@packages/ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  speechId: string;
  excerpt: string;
};

const fbClient = new FirebaseClient();

export const SpeechExcerpt = ({ speechId, excerpt }: Props) => {
  const { data: paymentData, isFetching: isPaymentFetching } = useQuery({
    queryKey: [QUERY_KEYS.SPEECH, speechId, 'paymentDetails'],
    queryFn: () => fbClient.getPaymentUrl({ id: speechId }),
  });

  const { t } = useTranslation();

  return (
    <div className="w-full h-full grid place-items-center">
      <h1 className="text-2xl font-bold mb-2 mt-8">{t('yourSpeech')}</h1>
      <p className="text-foreground/70">{t('speechExcerpt.thankYou')}</p>
      <p className="mb-8 text-foreground/70">{t('speechExcerpt.paymentNote')}</p>
      <div className="relative whitespace-pre-wrap max-w-[600px] bg-background p-6 rounded-md">
        {excerpt}...
        <div className="bg-gradient-to-b from-transparent to-white w-full h-[100px] absolute bottom-0 rounded-bl-md rounded-br-md left-0 right-0 z-10"></div>
      </div>
      <a href={paymentData?.data.url}>
        <Button
          className="mt-4"
          variant={'gradient'}
          loading={isPaymentFetching}
          disabled={isPaymentFetching}>
          {t('cta.buySpeech')}
        </Button>
      </a>
    </div>
  );
};
